import { render } from "./ModalAddEditVdeFunction.vue?vue&type=template&id=94a00078&scoped=true&ts=true"
import script from "./ModalAddEditVdeFunction.ts?vue&type=script&lang=ts"
export * from "./ModalAddEditVdeFunction.ts?vue&type=script&lang=ts"

import "./ModalAddEditVdeFunction.scss?vue&type=style&index=0&id=94a00078&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a00078"]])

export default __exports__